// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

.document-list {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.document-list__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}
.document-list__count {
  font-family: var(--font);
  font-weight: 400;
  font-size: 13px;
  opacity: 0.7;
}
.document-list__toggle {
  display: flex;
  gap: 2px;
}
.document-list__toggle ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
  width: 36px;
  height: 36px;
  opacity: 0.4;
  transition: opacity 0.2s ease;
}
.document-list__toggle ion-button.active {
  opacity: 1;
}
.document-list__toggle ion-button ion-icon {
  font-size: 20px;
}
.document-list__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  padding: 4px 0;
  overflow-y: auto;
  flex: 1;
  align-content: start;
}
@media (min-width: 1024px) {
  .document-list__grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 220px));
  }
}
.document-list__list {
  flex: 1;
  overflow: hidden;
}
.document-list__static-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.document-list__virtual-scroll {
  height: 100%;
  overflow-x: hidden;
}
.document-list__virtual-scroll ion-item {
  --padding-start: 8px;
  --inner-padding-end: 8px;
}
.document-list__skeleton {
  flex: 1;
  overflow: hidden;
}
.document-list__skeleton .skeleton-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.document-list__skeleton .skeleton-card__preview {
  height: 100px;
}
.document-list__skeleton .skeleton-card__body {
  padding: 10px 12px;
}

.selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}
.selection-bar__count {
  font-family: var(--font);
  font-weight: 600;
  font-size: 13px;
  opacity: 0.8;
}
.selection-bar__right {
  display: flex;
  align-items: center;
  gap: 2px;
}
.selection-bar__btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 12px;
  font-weight: 500;
  opacity: 0.65;
  transition: opacity 0.15s ease, background 0.15s ease;
  white-space: nowrap;
}
.selection-bar__btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}
.selection-bar__btn:active {
  background: rgba(0, 0, 0, 0.08);
}
.selection-bar__btn ion-icon {
  font-size: 16px;
  flex-shrink: 0;
}

ion-skeleton-text {
  --border-radius: 4px;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-list/document-list.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,4CAAA;EACA,kBAAA;AACJ;AAEE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,QAAA;AADJ;AAGI;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AADN;AAGM;EACE,UAAA;AADR;AAIM;EACE,eAAA;AAFR;AAOE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,oBAAA;AALJ;AAOI;EATF;IAUI,8DAAA;EAJJ;AACF;AAOE;EACE,OAAA;EACA,gBAAA;AALJ;AAQE;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;AANJ;AASE;EACE,YAAA;EACA,kBAAA;AAPJ;AASI;EACE,oBAAA;EACA,wBAAA;AAPN;AAWE;EACE,OAAA;EACA,gBAAA;AATJ;AAWI;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yCAAA;AATN;AAWM;EACE,aAAA;AATR;AAYM;EACE,kBAAA;AAVR;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;AAbF;AAeE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAbJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,UAAA;EACA,+BAAA;AAfN;AAkBI;EACE,+BAAA;AAhBN;AAmBI;EACE,eAAA;EACA,cAAA;AAjBN;;AAsBA;EACE,oBAAA;EACA,cAAA;AAnBF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.document-list {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 4px 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    margin-bottom: 8px;\n  }\n\n  &__count {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 13px;\n    opacity: 0.7;\n  }\n\n  &__toggle {\n    display: flex;\n    gap: 2px;\n\n    ion-button {\n      --padding-start: 8px;\n      --padding-end: 8px;\n      width: 36px;\n      height: 36px;\n      opacity: 0.4;\n      transition: opacity 0.2s ease;\n\n      &.active {\n        opacity: 1;\n      }\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 12px;\n    padding: 4px 0;\n    overflow-y: auto;\n    flex: 1;\n    align-content: start;\n\n    @media (min-width: 1024px) {\n      grid-template-columns: repeat(auto-fill, minmax(180px, 220px));\n    }\n  }\n\n  &__list {\n    flex: 1;\n    overflow: hidden;\n  }\n\n  &__static-scroll {\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n  }\n\n  &__virtual-scroll {\n    height: 100%;\n    overflow-x: hidden;\n\n    ion-item {\n      --padding-start: 8px;\n      --inner-padding-end: 8px;\n    }\n  }\n\n  &__skeleton {\n    flex: 1;\n    overflow: hidden;\n\n    .skeleton-card {\n      background: #fff;\n      border-radius: 10px;\n      overflow: hidden;\n      border: 1px solid rgba(0, 0, 0, 0.04);\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n\n      &__preview {\n        height: 100px;\n      }\n\n      &__body {\n        padding: 10px 12px;\n      }\n    }\n  }\n}\n\n.selection-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  margin-bottom: 8px;\n\n  &__count {\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 13px;\n    opacity: 0.8;\n  }\n\n  &__right {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n  }\n\n  &__btn {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-family: var(--font);\n    font-size: 12px;\n    font-weight: 500;\n    opacity: 0.65;\n    transition: opacity 0.15s ease, background 0.15s ease;\n    white-space: nowrap;\n\n    &:hover {\n      opacity: 1;\n      background: rgba(0, 0, 0, 0.04);\n    }\n\n    &:active {\n      background: rgba(0, 0, 0, 0.08);\n    }\n\n    ion-icon {\n      font-size: 16px;\n      flex-shrink: 0;\n    }\n  }\n}\n\nion-skeleton-text {\n  --border-radius: 4px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
